import config from 'config'
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import React from 'react'

export const UserRules = () => {
  return (
    <>
      <RoutingMenu activeScreen="userRules" />
      <div className=''>
        {/* <iframe
                    src={`${config.RootUrl}/faculty/library/view/rules/rules.php?isIframe=true`}
                    className="iframe col-md-12" >
                </iframe> */}

        {
          config.account == "faculty" ?
            <iframe
              src={`${config.RootUrl}/faculty/library/view/rules/rules.php?isIframe=true`}
              className="iframe col-md-12" >
            </iframe>
            :
            <iframe
              src={`${config.RootUrl}/student/library/view/rules/rules.php?isIframe=true`}
              className="iframe col-md-12" >
            </iframe>
        }

      </div>
    </>
  )
}
